import { Injectable } from '@angular/core';
import { DcLocalStorage } from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';

interface IProjectStorage {
	projectId: number;
	projectLabel: string;
	selectedContext: number;
	isJobsCacheActive: boolean;
}

const entityDefaults: IProjectStorage = {
	projectId: -1,
	projectLabel: 'no project',
	selectedContext: -1,
	isJobsCacheActive: true,
};

class UserSettings implements IProjectStorage {
	private [immerable] = true;
	public projectId = entityDefaults.projectId;
	public projectLabel = entityDefaults.projectLabel;
	public selectedContext = entityDefaults.selectedContext;
	public isJobsCacheActive = entityDefaults.isJobsCacheActive;

	public log(settings: UserSettings): void {
		// console.warn(
		// 	'%c [User Settings]:',
		// 	'color: #4CAF50; background-color: black; font-weight: bold',
		// 	JSON.stringify(settings)
		// );
	}

	public setProjectId(id: number): UserSettings {
		const updated = produce(this, (draft: UserSettings) => {
			draft.projectId = id;
		});
		this.log(updated);
		return updated;
	}

	public setProjectLabel(label: string): UserSettings {
		const updated = produce(this, (draft: UserSettings) => {
			draft.projectLabel = label;
		});
		this.log(updated);
		return updated;
	}

	public setSelectedContext(ctxIx: number): UserSettings {
		const updated = produce(this, (draft: UserSettings) => {
			draft.selectedContext = ctxIx;
		});
		this.log(updated);
		return updated;
	}

	public setIsJobsCacheActive(isActive: boolean): UserSettings {
		const updated = produce(this, (draft: UserSettings) => {
			draft.isJobsCacheActive = isActive;
		});
		this.log(updated);
		return updated;
	}
}

@Injectable()
export class ProjectStorage extends DcLocalStorage<IProjectStorage> {
	protected key = 'user';
	private settings;

	public constructor() {
		super();
		this.settings = new UserSettings();
		this.synchronize();
	}

	public setValue(val: IProjectStorage): void {
		const current = this.getValue();
		this.settings = this.settings
			.setProjectId(val.projectId)
			.setProjectLabel(val.projectLabel);
		this.setStorage({
			...current,
			...val,
		});
	}

	public getValue(): IProjectStorage {
		return this.settings;
	}

	public getProjectId(): number {
		return this.settings.projectId;
	}

	public getSelectedContext(): number {
		return this.settings.selectedContext;
	}

	public isJobsCacheActive(): boolean {
		return this.settings.isJobsCacheActive;
	}

	public setCurrentContext(ctx: number): void {
		this.settings = this.settings.setSelectedContext(ctx);
		this.setStorage(this.settings);
	}

	public setIsJobsCacheActive(isActive: boolean): void {
		this.settings = this.settings.setIsJobsCacheActive(isActive);
		this.setStorage(this.settings);
	}

	private synchronize(): void {}
}
